module.exports = __webpack_public_path__ + "img/federation-used.4d639f42.svg";